/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import { QueryClient } from '@tanstack/react-query';

const QUERY_STALE_TIME_MS = 60_000;

/**
 * Module-level singleton so non-component code (the auth store) can clear
 * cached queries on sign-out — otherwise a switched-in account briefly renders
 * the previous session's cached `me` profile and other data until a refetch.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: QUERY_STALE_TIME_MS,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Auth-related errors should not be retried — they typically
        // indicate the session is gone and the user must sign in again.
        if (error instanceof Error && /401|403/.test(error.message)) return false;
        return failureCount < 2;
      },
    },
    mutations: { retry: 0 },
  },
});
